import * as formatter from "../../../../utils/formatter";
import {sortCaret} from "../../../../_metronic/_helpers";
import {ALLOW_STATUS, PROV_STATUS} from "../../../../utils/codes";
// import {format, subDays} from "date-fns";
// export const defaultSorted = [{ dataField: "id", order: "asc" }];

export const tabs = ALLOW_STATUS;

export const provFilterOptions = PROV_STATUS.map(({key, label}) => ({ key, label }));

export const sizePerPageList = [
  {text: "10개 보기", value: 10},
  {text: "30개 보기", value: 30},
  {text: "50개 보기", value: 50},
  {text: "100개 보기", value: 100},
];

export const initialFilter = {
  filter: {
    catCd1: "",
    catCd2: "",
    goodsNo: "",
    goodsNm: "",
    startDt: "",
    endDt: "",
    splySttsCd: "",
    allowStatus: "",
  },
  sortOrder: "asc",
  sortField: "id",
  pageNumber: 1,
  pageSize: 30,
};

export const columns = [
  {
    keyField: "no",
    dataField: "no",
    text: "No.",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "goodsNo",
    text: "상품 코드",
    headerClasses: 'text-center',
    classes: 'text-center',
  },
  {
    keyField: "no",
    dataField: "catNm1",
    text: "카테고리",
    headerClasses: 'text-center',
    classes: 'text-left',
    formatter: formatter.category,
  },
  {
    keyField: "no",
    dataField: "goodsNm",
    text: "상품명",
    headerClasses: 'text-center',
    classes: 'text-left',
    formatter: formatter.prodName,
  },
  {
    keyField: "no",
    dataField: "normalPrc",
    text: "정가",
    headerClasses: 'text-center',
    classes: 'text-right',
    sort: true,
    sortCaret: sortCaret,
    formatter: formatter.price,
  },
  {
    keyField: "no",
    dataField: "salePrc",
    text: "판매가",
    headerClasses: 'text-center',
    classes: 'text-right',
    sort: true,
    sortCaret: sortCaret,
    formatter: formatter.price,
  },
  {
    keyField: "no",
    dataField: "regDtime",
    text: "상품 등록일",
    headerClasses: 'text-center',
    classes: 'text-center',
    sort: true,
    sortCaret: sortCaret,
    formatter: formatter.date
  },
];
